import AdminCreatedMatches from '@commons/matches/admin-created'
import React from 'react'

const AdminCreated = () => {
  return <AdminCreatedMatches />
}

export default AdminCreated
